import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const ScrollToTopComponent = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export { ScrollToTopComponent as ScrollToTop };
